import { Component, Input, inject } from '@angular/core';
import { FormArray } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { ItemComponent } from '@tecalisdev/infinity';

import { IFormFieldPreset } from '../form-field-presets';
import { resolvePresetFieldPreviewTypeLabel } from '../form-step-field-labels';

@Component({
	selector: 'app-form-step-field-preview-list',
	imports: [ItemComponent],
	templateUrl: './form-step-field-preview-list.component.html',
})
export class FormStepFieldPreviewListComponent {
	private trans = inject(TranslateService);

	@Input({ required: true }) fieldsArray!: FormArray;
	@Input() preset?: IFormFieldPreset;

	public previewTypeLabel(index: number): string {
		const fieldType = String(this.fieldsArray.at(index)?.get('type')?.value ?? 'text');

		return resolvePresetFieldPreviewTypeLabel(this.trans, this.preset, fieldType);
	}
}
